import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Host } from '../models/host.models';

@Injectable({
  providedIn: 'root'
})
export class HostService {

  selectedHost$: BehaviorSubject<Host> = new BehaviorSubject(null);

  constructor() { }
}
